import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, P, useIsInstalled, useIsInstallReady } from '@a-type/ui';
import { useLocalStorage } from '../hooks/useStorage.js';
import { InstallButton } from './InstallButton.js';
export function InstallHint({ content: contentStr, className, }) {
    const [isDismissed, setIsDismissed] = useLocalStorage('pwa-install-hint-dismissed', false);
    const installReady = useIsInstallReady();
    const isInstalled = useIsInstalled();
    if (isDismissed || isInstalled || !installReady) {
        return null;
    }
    return (_jsxs(Box, { surface: true, color: "primary", p: true, col: true, gap: true, items: "stretch", className: className, children: [_jsx(P, { children: contentStr }), _jsxs(Box, { gap: true, full: "width", items: "center", justify: "end", children: [_jsx(Button, { emphasis: "ghost", onClick: () => setIsDismissed(true), children: "Dismiss" }), _jsx(InstallButton, { emphasis: "primary", size: "default" })] })] }));
}
//# sourceMappingURL=InstallHint.js.map